module.exports = __webpack_public_path__ + "h5/img/ava1 (4).57231eb4.png";